import React, { Component } from 'react';
import { connect } from 'react-redux';
import "../../assets/css/dashboard.css";
import { NavLink, Outlet } from "react-router-dom";

class DashboardLayout extends Component {

    render() {
        const date = new Date();
        const datePart = new Intl.DateTimeFormat(undefined, {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        }).format(date);

        const user = this.props.user;
        let userDisplayName = '';

        if (Object.keys(user).length !== 0) {
            userDisplayName = user.name.trim().split(/\s+/)[0];
        }

        return (
            <div className="mjs-body mjs-dash-container">
                <div className="mjs-dash-container-left">
                    <div className="mjs-welcome-msg">
                        Welcome, <span>{userDisplayName}</span>
                        <p>{datePart}</p>
                    </div>
                    <ul>
                        <li>
                            <NavLink
                                to="/websites"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                <i className="fa-regular fa-window-restore mjs_text_grey mjs-mr-5"></i> Websites
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/domains"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                <i className="fa-solid fa-globe mjs_text_grey mjs-mr-5"></i> Domains
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/emails"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                <i className="fa-solid fa-envelope mjs_text_grey mjs-mr-5"></i> Emails
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/backups"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                <i className="fa-solid fa-database mjs_text_grey mjs-mr-5"></i> Backups
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/addons"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                <i class="fa-solid fa-puzzle-piece mjs_text_grey mjs-mr-5"></i> Addons
                            </NavLink>
                        </li>
                    </ul>

                    <ul>
                        <li>
                            <NavLink
                                to="/billing"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                <i className="fa-solid fa-credit-card mjs_text_grey mjs-mr-5"></i> Billing
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/support"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                <i class="fa-solid fa-ticket mjs_text_grey mjs-mr-5"></i> Support Tickets
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className="mjs-dash-container-right mjs-dash-main">
                    <Outlet />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}
export default connect(mapStateToProps)(DashboardLayout);
